export var formatTime12h = function (_, date) {
    return new Intl.DateTimeFormat('en-US', { timeStyle: 'short', hour12: true }).format(date);
};
//# sourceMappingURL=formatTime.js.map